export class ToggleChat {
  constructor($timeout, $rootScope, LikeService, LockService, toastr) {
    return {
      link: ($scope, element, attr) => {
        $(element).on('click', () => {
          let activeChat;

          if ($rootScope.isPanelActivate === 0 || $rootScope.isPanelActivate === 2) {
            $rootScope.isPanelActivate = 1;  // lock
            $timeout(() => {
              // check if user matches to requirements
              if ($scope.userData) {
                LockService.isBlocked($scope.userData._id, $rootScope.currentUserProfile._id)
                  .then((response) => { let result = response.data;
                    if (result.success) {
                      toastr.error('Has sido bloqueado por este usuario');
                      return;
                    }

                    LikeService.isMutualLiked($scope.userData._id, $rootScope.currentUserProfile._id)
                      .then((response) => { let resultMutual = response.data;
                        let isMutual = resultMutual.data;
                        let age = $rootScope.getAge($rootScope.currentUserProfile);

                        if (!isMutual && $scope.userData.filters.matchfilters) {
                          if ($scope.userData.filters.region && $scope.userData.filters.region._id !== $rootScope.currentUserProfile.region) {
                            toastr.error(`Debes cumplir con el filtro de contacto`);
                            return;
                          }

                          if ($scope.userData.filters.minage > age || $scope.userData.filters.maxage < age) {
                            toastr.error('Age doesn\'t match');
                            return;
                          }

                          if ($scope.userData.filters.photorequired && (!$rootScope.currentUserProfile.photoprofile.approved && !$rootScope.currentUserProfile.photoprofile.url)) {
                            toastr.error('Photo required to contact');
                            return;
                          }
                        }

                        if ($(element[0]).attr('userid')) {
                          if ($(element[0]).hasClass('userid_active') || $('a.userid_active').length) {
                            $('a.userid_active').removeClass('userid_active');
                            activeChat = true;
                          }
                          else {
                            $(element[0]).addClass('userid_active');
                            activeChat = false;
                          }
                        }
                        $rootScope.loadChatPanel($(element[0]).attr('userid') || false, $(element[0]).attr('onlydisconnect') || false, activeChat || false);
                      })

                  })
                  .catch((response) => { let err = response.data;
                    console.log(err);
                  })

              }
              else {
                if ($(element[0]).attr('userid')) {
                  if ($(element[0]).hasClass('userid_active') || $('a.userid_active').length) {
                    $('a.userid_active').removeClass('userid_active');
                    activeChat = true;
                  }
                  else {
                    $(element[0]).addClass('userid_active');
                    activeChat = false;
                  }
                }
                $rootScope.loadChatPanel($(element[0]).attr('userid') || false, $(element[0]).attr('onlydisconnect') || false, activeChat || false);
              }

              $rootScope.isPanelActivate = 2;

            }, 450);

          }
        });
      }
    }
  }
}
